import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'spw-icon',
  styleUrl: 'spw-icon.scss',
  shadow: true,
  assetsDirs: ['assets'],
})
export class SpwIcon {
  /** Permet de spécifier une référence d'icône Font Awesome */
  @Prop() icon: string;
  /** Permet de spécifier une variante de Font Awesome */
  @Prop() variant: 'fa-solid' | 'fa-brands' = 'fa-solid';

  render() {
    const iconClassName = `spw-icon ${this.variant} ${this.icon}`;
    return <i class={iconClassName}></i>;
  }
}
